import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=2bb31d0c&"
import script from "./Session.vue?vue&type=script&lang=js&"
export * from "./Session.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports